module.exports = __webpack_public_path__ + "img/youmu konpaku mysterious sword master_sc2.3d5850f9.png";